import PropTypes from 'prop-types';
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RecordsErrorBoundary({
  boundaryName,
  ErrorComponent,
  children,
  errorProps
}) {
  const handleOnComponentDidCatch = error => {
    CrmLogger.log('crmErrorBoundary', {
      action: error && (error.message || 'Unknown error'),
      type: boundaryName
    });
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    onComponentDidCatch: handleOnComponentDidCatch,
    ErrorComponent: ErrorComponent,
    errorProps: errorProps,
    children: children
  });
}
RecordsErrorBoundary.propTypes = {
  boundaryName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  ErrorComponent: PropTypes.func,
  errorProps: PropTypes.object
};